import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import * as qs from 'querystring';
import { Router as InvestmentsRouter } from 'components/InvestmentsRouter';
import { ModalsContainer } from 'components/ModalContainer';
import { MainPage } from 'modules/MainPage';
import { ExternalUserMenu } from 'shared/components/UserMenu/external';
import { GlobalStylesUTCom } from '@unitedtraders/utcom-ui-kit';

import * as apple_touch_pre from 'static/icons/apple-touch-icon-precomposed.png';
import * as apple_touch from 'static/icons/apple-touch-icon.png';
import * as icon from 'static/icons/favicon.png';
import * as splash_statup from 'static/icons/splash-statup.png';

export const Root: React.FC = () => {
  const { t } = useTranslation();

  const history = useHistory();

  const params = qs.parse(history.location.search.substr(1));

  React.useEffect(() => history.listen((_, action) => action !== 'POP' && window.scrollTo(0, 0)));

  return (
    <div>
      <Helmet>
        <link rel="icon" sizes="192x192" href={icon} />
        <link rel="apple-touch-icon" sizes="180x180" href={apple_touch} />
        <link rel="apple-touch-icon-precomposed" sizes="180x180" href={apple_touch_pre} />
        <link rel="apple-touch-startup-image" href={splash_statup} />
        <title>United Traders – {t('investment company')}</title>
        <meta name="description" content={t('Main site description')} />
      </Helmet>
      <GlobalStylesUTCom />
      <Switch>
        <Redirect
          exact
          from="/investments/exchange"
          to={{
            pathname: '/investments',
            search: `?${qs.stringify({ action: 'conversion', ...params })}`,
          }}
        />
        <Route path="/investments" component={InvestmentsRouter} />
        <Route path="/" component={MainPage} />
      </Switch>
      <ModalsContainer />
      <ExternalUserMenu />
    </div>
  );
};
